import React from 'react';
import {
  Col,
  Stack,
  FlexboxGrid,
  Form,
  SelectPicker,
  Input,
  Toggle
} from 'rsuite';
const BuyerExclusiveProduct = ({
  data5,
  label,
  buyeerdata,
  handleInputChange,
  fetchBuyers,
  setBuyeerdata,
  isLoadingbu,
  setIsLoadingbu,
  showInputs,
  setShowInputs
}) => {
  return (
    <div>
      <Form.Group controlId="input-group">
        <Stack spacing={6} justifyContent="space-between">
          <p>If Buyer Exclusive Product ? (Click on the toggle to enter Buyer details)</p>
          <Toggle checked={showInputs} onChange={value => setShowInputs(value)} />
        </Stack>
      </Form.Group>
      {data5.BuyerName && !showInputs && setShowInputs(true)}
      {showInputs && (
        <div>
          <FlexboxGrid justify="space-around">
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="input-group">
                <Form.ControlLabel>{label[0]?.attributes?.BuyerName}</Form.ControlLabel>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <SelectPicker
                    id="BuyerName"
                    name="BuyerName"
                    value={data5.BuyerName || ''}
                    onChange={value => handleInputChange('BuyerName', value, 0)}
                    data={buyeerdata}
                    placeholder={`Select ${label[0]?.attributes?.BuyerName}`}
                    labelKey="label"
                    valueKey="label"
                    placement="auto"
                    block
                    container={() => document.getElementById('custom-container')}
                    onOpen={() =>
                      fetchBuyers(
                        setBuyeerdata,
                        isLoadingbu,
                        setIsLoadingbu,
                        '&filters[dis][$ne]=Discontinue'
                      )
                    }
                    menuMaxHeight={180}
                    menuStyle={{ width: 200 }}
                  />
                </div>
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="input-group">
                <Form.ControlLabel>{label[0]?.attributes?.BuyerSku}</Form.ControlLabel>
                <Input
                  id="BuyerSku"
                  name="BuyerSku"
                  autoComplete="off"
                  value={data5 && data5.BuyerSku ? data5.BuyerSku : ''}
                  onChange={value => handleInputChange('BuyerSku', value, 0)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="input-group">
                <Form.ControlLabel>{label[0]?.attributes?.BuyerRemark}</Form.ControlLabel>
                <Input
                  id="Buyer_Remark"
                  name="Buyer_Remark"
                  autoComplete="off"
                  value={data5 && data5.Buyer_Remark ? data5.Buyer_Remark : ''}
                  onChange={value => handleInputChange('Buyer_Remark', value, 0)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </div>
      )}
    </div>
  );
};

export default BuyerExclusiveProduct;
